/**
 * Geometry types. Either preset or custom.
 */
export enum GeometryTypes {
    PRESET = "PRESET",
    CUSTOM = "CUSTOM",
    PEN = "PEN",
}
